//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.DB.js";
import "../no/TaggedObject.js";
let d=[[],[[["firstAttr","secondAttr","thirdAttr","fourthAttr"],"SetDocumentStructure",{},4,0],[["firstAttr","secondAttr","thirdAttr"],"SetDocumentStructure1",{},3,0],[["firstAttr","secondAttr"],"SetDocumentStructure2",{},2,0],[["firstAttr"],"SetDocumentStructure3",{},1,0],[[],"GetDocumentStructureString",{R_:{docStructString:''}},0,0],[["dccString"],"SetClassificationCode",{},1,0],[[],"GetClassificationCode",{R_:{dccString:''}},0,0]],[]];
SPLM.AME.DB.DocumentStructure = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.DB.DocumentStructure";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.AME.DB.DocumentStructure.Attribute = Object.freeze({
    "None" : "None", "Function" : "Function", "Location" : "Location", "Product" : "Product", "Dcc" : "Dcc"});

export default SPLM;